export enum ErrorDialog {
  internalServer = 'internal',
  authentication = 'authentication',
}
